module.exports = __webpack_public_path__ + "img/charging-battery-low-1.5fc64b13.svg";